// StarTap — scripts propios del tema (vanilla JS, sin librerías externas)

(function () {
  'use strict';

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;

    // Contrato de seguridad: en CSS, .mt-reveal es visible por defecto.
    // Aquí solo "armamos" (ocultamos para animar) los elementos que en este
    // instante están claramente por debajo de la pantalla — los que ya están
    // a la vista se quedan tal cual, visibles, sin animación (no hace falta).
    // Si algo falla más adelante (IntersectionObserver, timing, lo que sea),
    // como nunca los armamos, nunca se quedan invisibles.
    if (!('IntersectionObserver' in window)) return;

    var armados = [];
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top > window.innerHeight * 1.05) {
        el.classList.add('mt-armado');
        armados.push(el);
      }
    });
    if (!armados.length) return;

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -30px 0px' }
    );
    armados.forEach(function (el) { obs.observe(el); });

    // Red de seguridad final: si por lo que sea un elemento armado nunca
    // llega a intersectar (saltos de scroll instantáneos, pestaña en segundo
    // plano...), lo revelamos igualmente pasado un tiempo prudencial. Mejor
    // sin animación que invisible para siempre.
    setTimeout(function () {
      armados.forEach(function (el) {
        if (!el.classList.contains('mt-visible')) el.classList.add('mt-visible');
      });
    }, 4000);
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          obs.unobserve(el);
          var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
          var decimales = (el.getAttribute('data-mt-contador').split('.')[1] || '').length;
          var sufijo = el.getAttribute('data-mt-sufijo') || '';
          var duracion = 1400;
          var inicio = null;
          function paso(ts) {
            if (!inicio) inicio = ts;
            var progreso = Math.min((ts - inicio) / duracion, 1);
            var facilitado = 1 - Math.pow(1 - progreso, 3);
            var valor = fin * facilitado;
            el.textContent = valor.toFixed(decimales) + sufijo;
            if (progreso < 1) requestAnimationFrame(paso);
          }
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            el.textContent = fin.toFixed(decimales) + sufijo;
          } else {
            requestAnimationFrame(paso);
          }
        });
      },
      { threshold: 0.5 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initAcordeonFAQ() {
    var items = document.querySelectorAll('.mt-faq-item');
    if (!items.length) return;
    items.forEach(function (item) {
      var pregunta = item.querySelector('.mt-faq-pregunta');
      if (!pregunta) return;
      pregunta.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-faq-abierto');
        items.forEach(function (i) { i.classList.remove('mt-faq-abierto'); });
        if (!abierto) item.classList.add('mt-faq-abierto');
      });
    });
  }

  function initMarquesina() {
    var tracks = document.querySelectorAll('.mt-marquesina-track');
    tracks.forEach(function (track) {
      if (track.dataset.mtDuplicado) return;
      track.innerHTML += track.innerHTML;
      track.dataset.mtDuplicado = '1';
    });
  }

  function initTiltTarjetas() {
    if (window.matchMedia('(hover: none)').matches) return;
    var tarjetas = document.querySelectorAll('[data-mt-tilt]');
    tarjetas.forEach(function (t) {
      t.addEventListener('mousemove', function (e) {
        var r = t.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        t.style.transform = 'perspective(700px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
      });
      t.addEventListener('mouseleave', function () { t.style.transform = ''; });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContadores();
    initAcordeonFAQ();
    initMarquesina();
    initTiltTarjetas();
  });
})();
